import { render, staticRenderFns } from "./PresentingRightEditBox.vue?vue&type=template&id=fad35a24&scoped=true&"
import script from "./PresentingRightEditBox.vue?vue&type=script&lang=js&"
export * from "./PresentingRightEditBox.vue?vue&type=script&lang=js&"
import style0 from "./PresentingRightEditBox.vue?vue&type=style&index=0&id=fad35a24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad35a24",
  null
  
)

export default component.exports